import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import AlterationLayout from "./AlterationLayout";
import { listenToWorkflowCollection } from "../../services/workflowCatalogService";
import { updateAlterationDraft } from "../../lib/alterationDraft";

const imageOf = (item) => item.imageUrl || item.image || item.mainImage || item.thumbnailUrl || "";

export default function AlterationGarmentsPage() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ items: [], loading: true, error: "" });

  useEffect(() => listenToWorkflowCollection("garments", (items) => {
    const matches = items.filter((item) => [item.sectionId, item.stitchingCategoryId, item.categoryId].map(String).includes(String(groupId)));
    setState({ items: matches, loading: false, error: "" });
  }, () => setState({ items: [], loading: false, error: "Unable to load garments." })), [groupId]);

  const open = (garment) => {
    updateAlterationDraft({
      categoryId: groupId,
      garmentId: garment.id,
      garment: { id: garment.id, name: garment.name || garment.title || "Garment", image: imageOf(garment), sectionId: groupId },
      services: [],
    });
    navigate(`/services/alterations/${garment.id}`);
  };

  return <AlterationLayout back={() => navigate("/services/alterations")} title="Choose a garment" intro="Select the garment you want altered or repaired.">
    <div className="mt-10">
      {state.loading ? <div className="card-soft p-8">Loading garments…</div> : state.error ? <div className="card-soft p-8 text-red-600">{state.error}</div> : !state.items.length ? <div className="card-soft p-8 text-center"><h2 className="font-display text-2xl">No garments available yet</h2><p className="text-sm text-[#5b5a56] mt-2">Garments assigned to this category in the admin panel will appear here.</p></div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{state.items.map((garment) => <button key={garment.id} type="button" onClick={() => open(garment)} className="card-soft text-left overflow-hidden lift"><div className="aspect-[4/3] bg-[#FFF3E8]">{imageOf(garment) ? <img src={imageOf(garment)} alt={garment.name || "Garment"} className="w-full h-full object-contain object-center" /> : <div className="h-full flex items-center justify-center text-[#F46524] font-semibold">{garment.name || garment.title}</div>}</div><div className="p-6 flex items-center justify-between gap-3"><h2 className="font-display text-2xl">{garment.name || garment.title}</h2><ArrowRight className="text-[#F46524] shrink-0" /></div></button>)}</div>}
    </div>
  </AlterationLayout>;
}

